// React
import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

// API
import { useBenchmarkCollections } from "../../api/benchmarking/BenchmarkCollectionsAPI";
import { useBenchmarking } from "../../api/benchmarking-control/BenchmarkingControlAPI";

// Components
import BenchmarkingCollectionsProfile from "./BenchmarkCollectionsProfile.components";
import BenchmarkingCollectionsAnalysis from "./BenchmarkCollectionsAnalysis";

// Styling

import "./BenchmarkCollections.css";

BenchmarkCollections.propTypes = {
  auth: PropTypes.object,
  user: PropTypes.object,
};

function BenchmarkCollections(props) {
  const { user } = props.auth;

  // Dashboard
  const [showDashboard, setShowDashboard] = useState(false);

  const [selectedCollection, setSelectedCollection] = useState({});
  const [loadedCollection, setLoadedCollection] = useState({});

  // Benchmark Data
  const { benchmarking } = useBenchmarking(user);
  const { benchmarkCollections } = useBenchmarkCollections();

  return (
    <div className="page-background">
      <div className="left-nav-pane-backer">
        <div className="left-nav-pane">
          <div className="left-nav-pane-content">
            <div className="left-nav-pane-title">
              <h1 className="display-4">Benchmarking</h1>
            </div>
            <div className="project-control-panel">
              <div className="project-control-drawer">
                <button
                  className="drawer-button"
                  onClick={() => {
                    setShowDashboard(!showDashboard);
                  }}
                >
                  Dashboard Panel
                </button>
              </div>
              <div className="project-control-drawer">
                <BenchmarkingCollectionsProfile
                  user={user}
                  benchmarking={benchmarking}
                  benchmarkCollections={benchmarkCollections}
                  selectedCollection={selectedCollection}
                  setSelectedCollection={setSelectedCollection}
                  setLoadedCollection={setLoadedCollection}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-content-container">
        <div className="page-content">
          <BenchmarkingCollectionsAnalysis
            user={user}
            loadedCollection={loadedCollection}
            setLoadedCollection={setLoadedCollection}
            showDashboard={showDashboard}
            setShowDashboard={setShowDashboard}
          />
        </div>
      </div>
    </div>
  );
}

export default connect((state) => ({
  auth: state.auth,
}))(BenchmarkCollections);
